import { connect } from 'react-redux';
import ConnectableInstanceWidgetStatistic from 'client/components/Instance/components/ConnectableInstanceWidgetStatistic';
import { instanceFatdReadStatistics } from 'client/redux/fatd/statisticsActions';
import _ from 'lodash';

const mapStateToProps =  (state, props) => {
  const id = props.statistic;
  return {
    ...(state.fatd.statistics[id] || {}),
    data: _.get(state, ['fatd', 'statistics', id, 'data', id], null),
  };
};

const actions = {
  readStatistic: instanceFatdReadStatistics,
};

export default connect(mapStateToProps, actions)(ConnectableInstanceWidgetStatistic);
